import { Col, Row, Select } from "antd";
import React from "react";
import { connect } from "react-redux";
import { getAllKpis, getKpiSelected, getSummaryKpiId, getTableLoading } from "../../../selectors";
import { changeSummaryKpi } from "../../../actions/stats";
import _ from "lodash";
import { kpis as KPIS } from "./../../../../../configs/kpis";
const { Option } = Select;

const Kpis = props => {
  const getOptions = () => {
    const options = [];
    let kpis = props.kpis || [];
    kpis = _.orderBy(kpis, ["dashboard_ppriority", "priority", "label"], ["ASC", "ASC", "ASC"]);
    const mainKpi = props.mainKpi;
    if (!mainKpi) return [];
    let mainKpiDependencyId = null;
    let mainKpiGroup = null;
    if (mainKpi && mainKpi.kpi_dependencies) {
      mainKpiDependencyId = parseInt(mainKpi.kpi_dependencies[0]) || mainKpi.id;
    }
    if (mainKpi && mainKpi.display_group) {
      mainKpiGroup = mainKpi.display_group[0];
    }
    options.push(
      <Option key={0} value={mainKpi.id}>
        {mainKpi.long_label || ""}
      </Option>
    );
    //TODO remove
    if (mainKpi.id === KPIS.MEA || mainKpi.id === KPIS.PLV || mainKpi.id === KPIS.NB_BRI) return options;

    for (let i = 0; i < kpis.length; i++) {
      const kpi = kpis[i];
      if (
        kpi.id !== mainKpi.id &&
        kpi.calculation_type !== "Variation" &&
        kpi.dashboard_display &&
        kpi.display_group.indexOf(mainKpiGroup) !== -1
        //(kpi.id === mainKpiDependencyId || kpi.kpi_dependencies.indexOf(mainKpiDependencyId + "") !== -1)
      ) {
        options.push(
          <Option key={i + 1} value={kpi.id}>
            {kpi.long_label || ""}
          </Option>
        );
      }
    }
    return options;
  };

  //const filteredOptions = getOptions().filter(o => !getOptions().includes(o));
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Select
          size="default"
          style={{ width: "100%" }}
          value={props.summaryKpiId}
          allowClear={false}
          disabled={props.loading}
          onChange={data => {
            props.changeSummaryKpi(data);
          }}
        >
          {getOptions()}
        </Select>
      </Col>
    </Row>
  );
};

//REDUX
const mapStateToProps = state => {
  const kpis = getAllKpis(state);
  const summaryKpiId = getSummaryKpiId(state);
  const mainKpi = getKpiSelected(state);
  const loading = getTableLoading(state);
  return { kpis, summaryKpiId, mainKpi, loading };
};

export default connect(mapStateToProps, { changeSummaryKpi })(Kpis);



// WEBPACK FOOTER //
// src/modules/stats/containers/summary/filters/Kpis.js